<template>
  <div v-if="richData" class="think">
    <div class="title" @click="toggleExpand">
      <a-icon type="right" class="right" :class="{ 'anticon-shrink': isExpanded }" />
      <span>已深度思考</span>
      <span v-if="time != 0">（{{ time }}）秒</span>
    </div>
    <div v-html="marked(richData)" class="richContent markdown-body" v-show="isExpanded"></div>
  </div>
</template>

<script>
import { marked } from 'marked'
import throttle from 'lodash.throttle'
export default {
  data() {
    return {
      richDataCopy: '',
      isExpanded: true
    }
  },
  props: {
    time: {
      type: Number,
      default: 0
    },
    richData: {
      type: String,
      default: ''
    }
  },
  watch: {
    richData(val) {
      this.richDataCopy = marked(val)
    }
  },
  methods: {
    marked(data) {
      return marked(data)
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded
    }
  },
  mounted() {}
}
</script>

<style scoped lang="less">
.think{
  padding: 10px;
  // background-color: #f8f8f8;
  margin-top: 10px;
  border-radius: 4px;
  > .title{
    display: flex;
    align-items: center;
    cursor: pointer;
    .right{
      transition: transform 0.3s ease;
    }
    .anticon-shrink {
      transform: rotate(90deg);
    }
    span{
      margin-left: 4px;
    }
  }
  .richContent{
    margin-top: 10px;
  }
}
</style>
<style lang="less">
.richContent think{
  color: #999;
  font-size: 14px;
}
.markdown-body {
  box-sizing: border-box;
  padding: 20px;
  img {
    display: block;
  }
}
</style>
